/* import __COLOCATED_TEMPLATE__ from './signup-progress-bar.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { BUYER_SIGNUP_FLOWS } from 'sh-www/constants/buyer-signup-step';
import WorkIcon from 'sh-www/components/icons/work-icon';
import PersonIcon from 'sh-www/components/icons/person-icon';
import CreditCardIcon from 'sh-www/components/icons/credit-card-icon';
import MarkEmailReadOutlineIcon from 'sh-www/components/icons/mark-email-read-outline-icon';

const CLASS_NAME = 'GLM-signup-progress-bar';

export const BUYER_SIGNUP_LABELS = {
  ABOUT_YOU: 'About You',
  COMPANY_INFO: 'Company Info',
  PAYMENT_METHOD: 'Payment Method',
  VERIFY_EMAIL: 'Verify Email',
};

const STEPS_TO_LABELS = {
  [EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__ABOUT_YOU]: BUYER_SIGNUP_LABELS.ABOUT_YOU,
  [EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__COMPANY_INFO]: BUYER_SIGNUP_LABELS.COMPANY_INFO,
  [EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__PAYMENT_METHOD]: BUYER_SIGNUP_LABELS.PAYMENT_METHOD,
  [EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__VERIFY_EMAIL]: BUYER_SIGNUP_LABELS.VERIFY_EMAIL,
};

export const STEP_STATUS = {
  CURRENT: 'current',
  COMPLETE: 'complete',
  PENDING: 'pending',
};

// Calculates which buyer steps to show for the progress bar based on the flow version
export const getSignupProgressSteps = (flow) => {
  switch (flow) {
    case BUYER_SIGNUP_FLOWS.BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW:
      return [
        { label: BUYER_SIGNUP_LABELS.ABOUT_YOU, icon: PersonIcon },
        { label: BUYER_SIGNUP_LABELS.COMPANY_INFO, icon: WorkIcon },
        { label: BUYER_SIGNUP_LABELS.PAYMENT_METHOD, icon: CreditCardIcon },
        { label: BUYER_SIGNUP_LABELS.VERIFY_EMAIL, icon: MarkEmailReadOutlineIcon },
      ];

    case BUYER_SIGNUP_FLOWS.BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW_SSO:
      return [
        { label: BUYER_SIGNUP_LABELS.ABOUT_YOU, icon: PersonIcon },
        { label: BUYER_SIGNUP_LABELS.COMPANY_INFO, icon: WorkIcon },
        { label: BUYER_SIGNUP_LABELS.PAYMENT_METHOD, icon: CreditCardIcon },
      ];

    case BUYER_SIGNUP_FLOWS.BUYER_SIGNUP_WITHOUT_PAYMENT_METHOD_FLOW:
      return [
        { label: BUYER_SIGNUP_LABELS.ABOUT_YOU, icon: PersonIcon },
        { label: BUYER_SIGNUP_LABELS.COMPANY_INFO, icon: WorkIcon },
        { label: BUYER_SIGNUP_LABELS.VERIFY_EMAIL, icon: MarkEmailReadOutlineIcon },
      ];

    default:
      return [
        { label: BUYER_SIGNUP_LABELS.ABOUT_YOU, icon: PersonIcon },
        { label: BUYER_SIGNUP_LABELS.COMPANY_INFO, icon: WorkIcon },
      ];
  }
};

class SignupProgressBarComponent extends Component {
  @service media;

  get className() {
    return CLASS_NAME;
  }

  get steps() {
    const stepLabel = STEPS_TO_LABELS[this.args.currentStep];
    const steps = getSignupProgressSteps(this.args.flow);

    let stepFound = false;

    steps.forEach((step) => {
      if (step.label === stepLabel) {
        step.status = STEP_STATUS.CURRENT;
        stepFound = true;
      } else if (!stepFound) {
        step.status = STEP_STATUS.COMPLETE;
      } else {
        step.status = STEP_STATUS.PENDING;
      }
    });

    return steps;
  }

  @action
  shouldShowIcon({ status }) {
    return this.media.isMobile || status !== STEP_STATUS.COMPLETE;
  }
}

export default SignupProgressBarComponent;
